export default __webpack_public_path__ + "assets/images/c130c0685ebc486d4872a03fe640c827.svg";